<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div class="pbr6_rules">
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="prio"
        class="elevation-1">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IPv6 PBR rules</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
            <div>
                <ipv6_route_table_box v-model="show_ipv6_route_table_form"
                    @canceled="on_ipv6_route_table_form_cancel()"
                    @selected="on_ipv6_route_table_form_select($event)">
                </ipv6_route_table_box>
            </div>
            <div>
                <prefix_map_box v-model="show_prefix_map_box"
                    @canceled="on_prefix_map_box_cancel()"
                    @selected="on_prefix_map_box_select($event)">
                </prefix_map_box>
            </div>

            <template v-slot:activator="{ props }">
                <v-btn @click="new_item(item)"
                    color="primary" dark class="mb-2"
                    v-bind="props">
                    Add PBR rule
                </v-btn>
            </template>

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                <v-card-title>
                    <span class="headline">{{ form_title }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <div class="br_label">
                            type
                            <treeselect
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.type"
                                :multiple="false" 
                                :options="rule_types"
                            />
                        </div>

                        <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.prio"
                                label="Priority"
                            ></v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <div v-if="edited_item.type !== 8">
                            <ValidationProvider rules="required|rt_name" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.rt"
                                    label="Route table">
                                    <template v-if="edited_index == -1" #append>
                                        <v-btn @click="open_ipv6_route_table_form()">...</v-btn>
                                    </template>                          
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 3">
                            <ValidationProvider rules="required|ipv6_prefix" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.from_prefix"
                                    label="IPv6 prefix">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 7 || edited_item.type === 8">
                            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.prefix_map_id"
                                    label="Prefix map ID">
                                    <template v-if="edited_index == -1" #append>
                                        <v-btn @click="open_prefix_map_box()">...</v-btn>
                                    </template>                          
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 2">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.l2set"
                                    label="L2 set">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>                        
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn v-if="edited_index === -1" color="blue darken-1" 
                        :disabled="invalid" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-form></v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>   

        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small @click="delete_item(item)">
            mdi-delete
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import ipv6_route_table_box from "../components/ipv6_route_table_box.vue";
import prefix_map_box from "../components/prefix_map_box.vue";
import "../validation_rules.js"

export default {

name: "pbr6_rules",

components: { 
    Treeselect, ValidationProvider, ValidationObserver,
    ipv6_route_table_box, prefix_map_box
},

data: () => ({
    show_ipv6_route_table_form: false,
    show_prefix_map_box: false,
    pbr_rules: [],
    search: '',
    dialog: false,
    headers: [
        { text: 'Prio', value: 'prio', align: 'start' },
        { text: 'Condition', value: 'cond' },
        { text: 'Route table', value: 'rt' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        type: -1,
        prio: '',
        cond: '',
        rt: '',
        from_prefix: '',
        to_prefix: '',
        prefix_map_id: '',
        proto: '',
        l2set: '',
    },
    rule_types: [
          {
            id: -1,
            label: '',
          },
          {
            id: 2,
            label: 'l2set',
          },
          {
            id: 3,
            label: 'from ipv6 prefix',
          },
          {
            id: 7,
            label: 'prefix map',
          },
          {
            id: 8,
            label: 'prefix map ext',
          },
        ],    
}),

computed: {
    form_title() {
        return this.edited_index === -1 ? 'Add IPv6 PBR rule' : 'IPv6 PBR rule'
    },
},

watch: {
},

created() {
    this.initialize()
},

methods: {
    on_ipv6_route_table_form_cancel() {
        this.show_ipv6_route_table_form = false;
    },

    on_ipv6_route_table_form_select(rt_name) {
        this.edited_item.rt = rt_name;
        this.show_ipv6_route_table_form = false;
    },

    open_ipv6_route_table_form() {
        this.show_ipv6_route_table_form = true;
    },

    on_prefix_map_box_cancel() {
        this.show_prefix_map_box = false;
    },

    on_prefix_map_box_select(prefix_map_id) {
        this.edited_item.prefix_map_id = prefix_map_id;
        this.show_prefix_map_box = false;
    },

    open_prefix_map_box() {
        this.show_prefix_map_box = true;
    },

    initialize() {
        // Load PBR rules
        return new Promise((resolve, reject) => {
            api_client.run_post_query("/pbr6_rules/show")
            .then(response => {
                if (response.data.hasOwnProperty("pbr_rules")) {
                    this.items = response.data.pbr_rules;
                    resolve(response);
                }
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    new_item() {
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });          
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.dialog = true;
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete PBR rule '" + 
            this.edited_item.cond + "', prio " + this.edited_item.prio + " ?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.run_post_query('pbr6_rules/del', {
            prio: this.edited_item.prio,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
        this.items.splice(this.edited_index, 1);
    },

    save_ipv6_prefix_rule()
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            prefix: this.edited_item.from_prefix,
        };

        api_client.run_post_query('/pbr6_rules/add_from_prefix', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: this.edited_item.type,
                    cond: "from " + this.edited_item.from_prefix,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_prefix_map_rule()
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            prefix_map_id: this.edited_item.prefix_map_id,
        };

        api_client.run_post_query('/pbr6_rules/add_prefix_map', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: 7,
                    cond: "prefix map " + this.edited_item.prefix_map_id,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_prefix_map_ext_rule()
    {
        let new_rule = {
            prio: this.edited_item.prio,
            prefix_map_id: this.edited_item.prefix_map_id,
        };

        api_client.run_post_query('/pbr6_rules/add_prefix_map_ext', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: 'selected by prefix map',
                    type: 8,
                    cond: "prefix map " + this.edited_item.prefix_map_id,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_u32set_rule(set_name)
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            l2set: set_name,
        };

        api_client.run_post_query('/pbr6_rules/add_l2set', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: 2,
                    cond: "l2set " + set_name
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save() {
        let type = this.edited_item.type;

        if (type === -1) {
            this.$fire({title: "Notice",
                text: 'rule type should not be empty', type: "warning"});
            return;
        }

        if (type === 2) {
            // ipset
            this.save_u32set_rule(this.edited_item.l2set);
        }        
        else if (type === 3) {
            // ipv6 prefix
            this.save_ipv6_prefix_rule();
        }
        else if (type === 7) {
            // prefix map
            this.save_prefix_map_rule();
        }
        else if (type === 8) {
            // prefix map
            this.save_prefix_map_ext_rule();
        }
    },

    on_nh_dbl_click(event, data) {
        if (this.edited_index != -1)
            return;
        this.edit_nh(data.item);
    },    
}

};
</script>
